import React, { useState } from 'react';
import { Container } from '@fiverr-private/layout_components';
import { CollapsibleProps } from './types';
import { CollapsibleContext } from './CollapsibleContext';

const Collapsible = ({
  defaultExpanded = false,
  expanded: controlledExpanded,
  onToggle = () => undefined,
  disabled,
  children,
  paddingBottom = '0',
  overflow,
}: CollapsibleProps) => {
  const [innerExpanded, setInnerExpanded] = useState(defaultExpanded);
  const expanded = controlledExpanded === undefined ? innerExpanded : controlledExpanded;

  const toggleExpanded = () => {
    if (disabled) {
      return;
    }

    onToggle(!expanded);
    setInnerExpanded(!expanded);
  };

  return (
    <CollapsibleContext.Provider value={{ expanded, toggleExpanded, disabled }}>
      <Container
        as="article"
        pointerEvents={disabled ? 'none' : undefined}
        paddingBottom={paddingBottom}
        overflow={overflow}
      >
        {children}
      </Container>
    </CollapsibleContext.Provider>
  );
};

Collapsible.displayName = 'Collapsible';

export default Collapsible;
